var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediumLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_48332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.64069 0C8.756 0 11.2812 2.50802 11.2812 5.60161C11.2812 8.69519 8.75581 11.203 5.64069 11.203C2.52561 11.203 0 8.69519 0 5.60161C0 2.50802 2.52542 0 5.64069 0ZM14.6485 0.328128C16.2061 0.328128 17.4688 2.68891 17.4688 5.60161C17.4688 8.51356 16.2063 10.8751 14.6487 10.8751C13.0911 10.8751 11.8283 8.51356 11.8283 5.60161C11.8283 2.68966 13.0909 0.328128 14.6485 0.328128ZM19.0081 0.8774C19.5557 0.8774 20 2.99246 20 5.60161C20 8.21 19.556 10.3258 19.0081 10.3258C18.4602 10.3258 18.0164 8.21056 18.0164 5.60161C18.0164 2.99265 18.4604 0.8774 19.0081 0.8774Z",
    fill: "#94A3B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_48332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 11.25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumLogo);
export default __webpack_public_path__ + "static/media/medium_logo.759d19016ec8c3518f0b609fa27bdced.svg";
export { ForwardRef as ReactComponent };